"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Display an icon from the SVG icon library.
 *
 * Copyright (C) 2017 Noom, Inc.
 * @author hubert
*/
var Icon = function Icon(_ref) {
  var icon = _ref.icon,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: className || "svg-icon"
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#".concat(icon)
  }));
};

var _default = Icon;
exports["default"] = _default;